export const primitiveColors = {
	gray: {
		50: '#FFF',
		100: '#F1F4F7',
		200: '#D9E1E6',
		300: '#beccd5',
		400: '#8A9CAB',
		500: '#5E5E73',
		600: '#3D4156',
	},
	grayDark: {
		300: '#595f73',
		400: '#474c5c',
		450: '#393d4c',
		500: '#292d38',
		600: '#1f2129',
	},
	primary: {
		500: '#009DE9',
		400: '#3DBDFF',
	},
	secondary: {
		500: '#a4d784',
		600: '#8DC16D',
	},
	accent: {
		500: '#FAC248',
		// Смесь 500/600 (30/70): белый текст читается, а 600 уже уходит в коричневый.
		550: '#E9A22B',
		600: '#E2941F',
	},
	success: { 500: '#8DC16D' },
	error: { 500: '#FA7079' },
	alpha: {
		black25: 'rgba(0, 0, 0, 0.25)',
		primary20: 'rgba(0, 157, 233, 0.2)',
		secondary20: 'rgba(174, 226, 142, 0.2)',
		accent20: 'rgba(250, 194, 72, 0.2)',
		error20: 'rgba(250, 112, 121, 0.2)',
		// Полупрозрачный белый — для UI-элементов поверх цветного/тёмного фона,
		// где нужен текст/обводка разной «громкости» без привязки к теме
		// (inverse/on-color контексты: tabs variant="white", бейджи на карточках
		// и т.п.). Дефолт темы остаётся нетронутым.
		white35: 'rgba(255, 255, 255, 0.35)',
		white65: 'rgba(255, 255, 255, 0.65)',
	},
	gradient: {
		primary: 'linear-gradient(308.92deg, #96EDFF -1.36%, #02A0EA 92.91%)',
		green: 'linear-gradient(105.44deg, #55CF88 2.25%, #CBE994 100%)',
		orange: 'linear-gradient(105.44deg, #FB9F6C 2.25%, #FFCF58 100%)',
		purple: 'linear-gradient(105.44deg, #BA68C8 2.25%, #FFB7D6 100%)',
	},
	testBg: {
		primary: '#5f5e7b',
		secondary: '#6B6FBC',
		brightDark: '#48467A',
		darkBlue: '#29549C',
		brightGreen: '#3C9AB1',
		neutral: '#595A5D',
	},
	scale: {
		level1: '#ade28d',
		level2: '#d3d966',
		level3: '#f7ce52',
		level4: '#ffe493',
		level5: '#ffedb8',
		level6: '#fff5d9',
	},
} as const;

export const gradient = primitiveColors.gradient;
